"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const eccrypto = __importStar(require("eccrypto-js"));
const randombytes_1 = __importDefault(require("randombytes"));
const common_1 = require("@affinidi/common");
const jolocomIdentityKey = "m/73'/0'/0'/0"; // eslint-disable-line
class KeysService extends common_1.KeysService {
    /* istanbul ignore next: private method */
    isValidPrivateKey(privateKey) {
        const { EC_GROUP_ORDER, ZERO32 } = eccrypto;
        const isValid = privateKey.compare(ZERO32) > 0 && privateKey.compare(EC_GROUP_ORDER) < 0;
        return isValid;
    }
    getEphemKeyPair() {
        return __awaiter(this, void 0, void 0, function* () {
            let ephemPrivateKey = yield randombytes_1.default(32);
            while (!this.isValidPrivateKey(ephemPrivateKey)) {
                ephemPrivateKey = yield randombytes_1.default(32);
            }
            return ephemPrivateKey;
        });
    }
    decryptByPrivateKey(encryptedDataString) {
        return __awaiter(this, void 0, void 0, function* () {
            const { seed, didMethod } = this.decryptSeed();
            const seedHex = seed.toString('hex');
            const privateKey = common_1.KeysService.getPrivateKey(seedHex, didMethod);
            const encryptedDataObject = JSON.parse(encryptedDataString);
            const { iv, ephemPublicKey, ciphertext, mac } = encryptedDataObject;
            if (!iv || !ephemPublicKey || !ciphertext || !mac) {
                console.error('Can not decrypt message');
                return encryptedDataObject;
            }
            const encryptedData = {
                iv: Buffer.from(iv, 'hex'),
                ephemPublicKey: Buffer.from(ephemPublicKey, 'hex'),
                ciphertext: Buffer.from(ciphertext, 'hex'),
                mac: Buffer.from(mac, 'hex'),
            };
            const dataBuffer = yield eccrypto.decrypt(privateKey, encryptedData);
            const data = JSON.parse(dataBuffer.toString());
            return data;
        });
    }
    encryptByPublicKey(publicKeyHex, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataString = JSON.stringify(data);
            const dataBuffer = Buffer.from(dataString);
            const publicKeyBuffer = Buffer.from(publicKeyHex, 'hex');
            const randomIv = yield randombytes_1.default(16);
            const ephemPrivateKey = yield this.getEphemKeyPair();
            const options = { iv: randomIv, ephemPrivateKey };
            const encryptedData = yield eccrypto.encrypt(publicKeyBuffer, dataBuffer, options);
            const { iv, ephemPublicKey, ciphertext, mac } = encryptedData;
            const serializedEncryptedData = {
                iv: iv.toString('hex'),
                ephemPublicKey: ephemPublicKey.toString('hex'),
                ciphertext: ciphertext.toString('hex'),
                mac: mac.toString('hex'),
            };
            const serializedEncryptedDataString = JSON.stringify(serializedEncryptedData);
            return serializedEncryptedDataString;
        });
    }
}
exports.default = KeysService;
//# sourceMappingURL=KeysService.js.map